<template>
  <div>
    <SettingsPagePanelHeader :showSubtitle="true">
      <template #title>フリーワード自動応答設定</template>
      <template #subtitle>
        フリーワードのメッセージをユーザーから受信したときに、ここで設定したメッセージで返信します。
      </template>
      <template #right>
        <RouterLink
          :to="{
            name: 'normalMessageChatReplySettingEdit',
          }"
        >
          <FlatButton :class="$style.button" v-if="!plannerSetting">
            <template #icon>
              <IconPlus :class="[$style.button__icon]" />
            </template>
            新規作成
          </FlatButton>
          <FlatButton :class="$style.button" v-else>
            <template #icon>
              <IconPen :class="[$style.button__icon]" />
            </template>
            編集
          </FlatButton>
        </RouterLink>
      </template>
    </SettingsPagePanelHeader>

    <section>
      <template v-if="!plannerSetting">
        <div :class="$style.noPlannerSetting">
          <p>設定が作成されていません。</p>
        </div>
      </template>
      <template v-else>
        <div>
          <p>
            <span :class="$style.title">現在のステータス: </span>
            <StateChip
              :text="plannerSetting.isEnabled ? '利用中' : '停止中'"
              :variation="plannerSetting.isEnabled ? 'positive' : 'negative'"
            />
          </p>
          <p :class="$style.title">設定中のメッセージ</p>
          <p :class="$style.body">{{ plannerSetting.message }}</p>
        </div>
      </template>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import IconPen from '@/components/icons/IconPen.vue'
import IconPlus from '@/components/icons/IconPlus.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import StateChip from '@/components/atoms/StateChip.vue'

import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import { useNormalMessageChatReplyPlannerSettingQuery } from './NormalMessageChatReplyView.generated'

const { result } = useNormalMessageChatReplyPlannerSettingQuery({
  fetchPolicy: 'no-cache',
})

const plannerSetting = computed(() => {
  if (result.value && result.value.normalMessageChatReplyPlannerSetting) {
    return result.value.normalMessageChatReplyPlannerSetting
  }
  return undefined
})
</script>

<style lang="scss" module>
.noPlannerSetting {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
}

.title {
  font-size: 14px;
  font-weight: 700;

  &:nth-child(n + 2) {
    margin-top: 16px;
  }
}

.body {
  white-space: pre-wrap;

  &:nth-child(n + 2) {
    margin-top: 16px;
  }
}
</style>
